export var getCardKey = function getCardKey(_ref) {
  var id = _ref.id,
    title = _ref.title;
  return id || String(title);
};
export var getBannerKey = function getBannerKey(_ref2) {
  var title = _ref2.title;
  return String(title);
};